import React, { Component } from "react";
import ProgressButton from "react-progress-button";
import Utils from "@utils";
import { OrganizationFavoriteGroupsService } from "@services";
import { Modal } from "../../../../../components";

class AddGroupModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			settings: {},
			buttonState: "",
			loading: false,
			form: {
				name: "",
				id: undefined,
			},
			validations: {
				name: null,
			},
		};

		this.initialState = { ...this.state };
	}

	openModal = settings => {
		this.setState({ showModal: true, settings, form: settings.form || undefined });
	};

	handleOnCancel = event => {
		if (event && event.type === "click") {
			event.preventDefault();
		}

		const { settings } = this.state;

		if (settings.onCancel) {
			settings.onCancel();
		}

		this.setState(this.initialState);
	};

	/**
	 * Creats a new officer group upon validation
	 * @param {Event} event An event used to prevent event bubbling
	 */
	submitForm = event => {
		if (event) {
			event.preventDefault();
		}

		const { lang } = global;

		if (!this.validateForm()) {
			this.updateProgressButton("error");
			return;
		}

		const { form } = this.state;

		this.updateProgressButton("loading");

		OrganizationFavoriteGroupsService.saveGroup(form)
			.then(() => {
				const { settings } = this.state;

				Utils.notify({
					type: "success",
					message: settings.form.id
						? lang.t("Group added successfully")
						: lang.t("Group updated sucessfully"),
					title: lang.t("Success"),
				});

				if (settings.onSuccess) {
					settings.onSuccess();
				}

				this.updateProgressButton("success", () => {
					this.setState(this.initialState);
				});
			})
			.catch(() => {
				Utils.notify({
					type: "error",
					message: lang.t("Error updating groups"),
					title: "Error",
				});

				this.updateProgressButton("error");
			});
	};

	updateProgressButton = (value, callback) => {
		this.setState({ buttonState: value }, callback);
	};

	/**
	 * Validates the required inputs in the form
	 * @param {Boolean} validateFields Determins if the changed feidl is valid
	 * @returns {Boolean} Determines if the changed form fields are valid
	 */
	validateForm = (validateFields = true) => {
		let valid = false;
		const { form } = this.state;

		valid = form.name !== "";

		if (validateFields) {
			// Reset fields
			const newValidations = this.initialState.validations;

			// Validate fields
			newValidations.name = form.name === "" ? "has-error" : "";

			this.setState({ validations: newValidations });
		}

		return valid;
	};

	handleOnRemoveGroup = () => {
		const { settings } = this.state;

		settings.onRemove();
	};

	handleKeyPress = event => {
		if (event.key === "Enter") {
			this.submitForm();
		}
	};

	handleOnChange = property => event => {
		const { form, validations } = this.state;

		form[property] = event.target.value;
		validations[property] = null;

		this.setState({ form, validations });
	};

	render() {
		const { lang } = global;
		const { state } = this;
		const { form } = state;
		const { validations } = state;

		return (
			<Modal
				show={state.showModal}
				onHide={this.handleOnCancel}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						{typeof form.id === "undefined" ? lang.t("New") : lang.t("Edit")}{" "}
						{lang.t("Group")}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-md-12">
							<div
								className={`form-group ${validations.name}`}
								htmlFor="add_group_modal_form_name"
							>
								<label
									className="control-label"
									htmlFor="add_group_modal_form_name"
								>
									{lang.t("Group Name")}
								</label>
								<input
									className="form-control"
									name="add_group_modal_form_name"
									value={form.name}
									onChange={this.handleOnChange("name")}
									onKeyPress={this.handleKeyPress}
								/>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<If condition={form.id}>
						<button
							type="button"
							className="btn btn-danger btn-medium pull-left"
							onClick={this.handleOnRemoveGroup}
						>
							{`${lang.t("Remove")} ${lang.t("Group")}`}
						</button>
					</If>
					<button
						type="button"
						className="btn btn-link"
						id="add-group-cancel"
						onClick={this.handleOnCancel}
					>
						{lang.t("Cancel")}
					</button>
					<ProgressButton
						id="save-new-group"
						className="btn btn-primary btn-medium"
						state={state.buttonState}
						onClick={this.submitForm}
					>
						{lang.t("Save")}
					</ProgressButton>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default AddGroupModal;
